import { Button } from '../../../components/Button/Button'
import { useFetchEmailThreads } from '../hooks'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../store/hooks'
import { selectEmailThreads, selectEmailThreadsHasMore, selectEmailThreadsMoreLoading, setEmailThreadsMoreLoading } from '../../../store/emailHub/emailThreads'
import { selectCustomEmailFilter } from '../../../store/emailHub/emailFilters'
import { useMemo } from 'react'
import { selectEmailContacts } from '../../../store/emailHub/emailUsers'

const subtractOneSecondFromDate = (isoString: string) => {
  try {
    const date = new Date(isoString)
    date.setSeconds(date.getSeconds() - 1)
    return date.toISOString()
  } catch {
    return isoString
  }
}

export const EmailTableLoadMoreButton = () => {
  const dispatch = useDispatch()

  const moreLoading = useAppSelector(selectEmailThreadsMoreLoading)
  const hasMore = useAppSelector(selectEmailThreadsHasMore)
  const currentFilter = useAppSelector(selectCustomEmailFilter)
  const emailThreads = useAppSelector(selectEmailThreads)
  const contacts = useAppSelector(selectEmailContacts)

  const { fetchEmailThreads } = useFetchEmailThreads()

  const beforeFilterForLoadMore = useMemo(() => {
    if (!contacts.length || !emailThreads.length) {
      return null
    }
    const { after } = currentFilter
    const contactEmailsInCurrentRange = emailThreads
      .flatMap((thread) => thread.emails)
      .filter((e) => (after ? e.createdAt > after : true))
      .filter((e) => contacts.some((c) => c.email?.toLowerCase() === e.sender.email.toLowerCase()))
    if (!contactEmailsInCurrentRange.length) {
      return null
    }
    const oldestContactEmailCreatedAt = contactEmailsInCurrentRange
      .map((e) => e.createdAt)
      .reduce((createdAt1, createdAt2) => (createdAt1 < createdAt2 ? createdAt1 : createdAt2))
    console.log(contactEmailsInCurrentRange)
    return subtractOneSecondFromDate(oldestContactEmailCreatedAt)
  }, [emailThreads, currentFilter, contacts])

  const loadMore = async () => {
    if (!beforeFilterForLoadMore) {
      return
    }
    const filter = {
      ...currentFilter,
      before: beforeFilterForLoadMore,
    }
    dispatch(setEmailThreadsMoreLoading(true))
    try {
      await fetchEmailThreads({ filter, clear: false })
    } finally {
      dispatch(setEmailThreadsMoreLoading(false))
    }
  }

  if (!hasMore) {
    if (emailThreads.length) {
      return <div className='p-3'>No more email threads found. Try extending your search range.</div>
    }
    return null
  }

  return (
    <Button variant='header' className='button-medium mt-3' onClick={loadMore} loading={moreLoading} disabled={!beforeFilterForLoadMore}>
      Load more
    </Button>
  )
}
